import { ResourceCategory } from '../../models/Resources';

const categories: ResourceCategory[] = [
  {
    id: 8888,
    title: 'Web Services',
    description: 'Information for Web services',
    displaySequence: 1,
    documents: [],
    subCategories: null,
  },
  {
    id: 1234,
    title: 'E-Verify Posters',
    description:
      'Upon enrollment, employers are required to clearly display the Notice of E-Verify Participation and Right to Work posters in English and Spanish, both of which appear below. Employers may also display the posters in other languages provided by DHS.',
    displaySequence: 1,
    documents: [],
    subCategories: '/categories/1234/subcategories',
  },
  {
    id: 5678,
    title: 'Manuals and Guides',
    description:
      'The following user manuals and guides are provided as a reference to users of E-Verify. These resources supplement and reinforce the online tutorials provided within the application.',
    displaySequence: 1,
    documents: [
      {
        title: 'E-Verify User Manual',
        type: 'external',
        link: 'https://www.e-verify.gov/e-verify-user-manual',
        displaySequence: 1,
      },
    ],
    subCategories: null,
  },
  {
    id: 6789,
    title: 'Other Resources',
    description: null,
    displaySequence: 2,
    documents: [
      {
        title: 'USCIS Home Page',
        type: 'external',
        link: 'http://www.uscis.gov',
        displaySequence: 1,
      },
      {
        title: 'E-Verify Home Page',
        type: 'external',
        link: 'https://www.e-verify.gov/',
        displaySequence: 2,
      },
      {
        title: 'I-9 Central Home Page',
        type: 'external',
        link: 'https://www.uscis.gov/i-9-central',
        displaySequence: 3,
      },
      {
        title: 'USCIS Press Room',
        type: 'external',
        link: 'https://www.uscis.gov/news',
        displaySequence: 4,
      },
    ],
    subCategories: '/categories/6789/subcategories',
  },
];

export default categories;
